const fitnessGoals = [
  // { label: "Adventure", value: "1" },
  { label: "Body Management", value: "2" },
  { label: "Body Sculpting", value: "3" },
  // { label: "Fun", value: "4" },
  { label: "Improving Cardiovascular Health", value: "5" },
  { label: "Increasing Flexibility", value: "6" },
  { label: "Maintaining Overall Health", value: "7" },
  { label: "Mood Enhancement", value: "8" },
  { label: "Muscle Building", value: "9" },
  // { label: "Pain Relief", value: "10" },
  { label: "Performance Enhancement", value: "11" },
  // { label: "Play as Game to Relax", value: "12" },
  // { label: "Play with Friends", value: "13" },
  // { label: "Posture Correction", value: "14" },
  // { label: "Routines", value: "15" },
  { label: "Stress Relief", value: "16" },
  { label: "Weight Loss", value: "17" },
];

export default fitnessGoals;